import {
CheckCircle,
Cancel,
} from '@mui/icons-material';
import { staffCategories } from './dataInfo';

export const recordsPerPage = 20;

// Gender options
export const genderOptions = [
    { id: 'male', name: 'Male' },
    { id: 'female', name: 'Female' },
    { id: 'other', name: 'Other' }
];

// Marital status options
export const maritalStatusOptions = [
        { id: 'single', name: 'Single' },
        { id: 'married', name: 'Married' },
        { id: 'divorced', name: 'Divorced' },
        { id: 'widowed', name: 'Widowed' }
    ];

// Function to get gender display text
export const getGenderText = (gender) => {
    const genderObj = genderOptions.find(g => g.id === gender);
    return genderObj ? genderObj.name : gender;
};

// Function to get marital status display text
export const getMaritalStatusText = (status) => {
    const statusObj = maritalStatusOptions.find(s => s.id === status);
    return statusObj ? statusObj.name : status;
};

    // Function to get status display text
export const getStatusText = (status) => {
        return status === '1' || status === 1 ? 'Active' : 'Inactive';
    };

    // Function to get status color
export const getStatusColor = (status) => {
        return status === '1' || status === 1 ? 'success' : 'error';
    };


    // Function to get status icon
export  const getStatusIcon = (status) => {
        return status === '1' || status === 1 ? <CheckCircle /> : <Cancel />;
    };


export const stringToColor = (str) => {
    if (!str) return '#1976d2'; // Default primary color
    
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    const hue = hash % 360;
    return `hsl(${hue}, 70%, 50%)`;
};
export const getInitials = (name) => {
    if (!name) return '??';
    
    const words = name.split(' ').filter(word => word.length > 0);
    
    if (words.length === 0) return '??';
    if (words.length === 1) return words[0].charAt(0).toUpperCase();
    
    return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase();
};

export const formatNumberWithComma = (numb) => {
    // Convert to number first
    const num = Number(numb);
    
    // Check if valid number
    if (isNaN(num) || !isFinite(num)) {
        return '0';
    }
    
    // Format the number
    const str = num.toString().split(".");
    str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return  "Sh"+" "+str.join(".");
};
export const recordsCount = (numb) => {
    // Convert to number first
    const num = Number(numb);

    // Check if valid number
    if (isNaN(num) || !isFinite(num)) {
        return '0';
    }
    // Format the number
    const str = num.toString().split(".");
    str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return str.join(".");
};
export const formatCreatedAtDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        month: 'short',    // "Mar"
        day: '2-digit',   // "02"
        year: 'numeric'    // "2025"
    });
};
// Nationality options
export const nationalityOptions = [
    { id: 'ugandan', name: 'Ugandan' },
    { id: 'other', name: 'Other' }
];


export const userOptions = [
        { id: 'AD', name: 'Admin User' },
        { id: 'ST', name: 'Staff User' },
    ];


export const roleOptions = [
        { id: 'CA', name: 'Cashier'},
        { id: 'NU', name: 'Nurse' },
        { id: 'DO', name: 'Doctor' },
        { id: 'AC', name: 'Accountant' },
        { id: 'PH', name: 'Pharmacist' },
        { id: 'RE', name: 'Receptionist' },
        { id: 'LA', name: 'Laboratory' },
        { id: 'HR', name: 'Human Resource' },
        { id: 'RA', name: 'Radiographer'},
        { id: 'TR', name: 'Triage'},
        { id: 'SK', name: 'Store Keeper'},
        { id: 'AG', name: 'Administrator General' },
    ];


export const getUserRole = (roleId) => {
    if (!roleId) return "Invalid Role";
    const item = roleOptions.find(item => item.id === roleId);
    return item?.name || "Unknown Role";
};


export const statusData =[
    {id:1,name:"Active"},
    {id:2,name:"Not-Active"},

];

export const getStatusById = (id) => {
    let Id = parseInt(id) ;
    const status = statusData.find(item => item.id === Id);
    return status?.name || "Un-known"
};


export const getNameById = (id, Data) => {
    let Id = parseInt(id);
    let nameFound = "Name Not found";
    const record = Data.find((item) => item.id === Id);
    if (record) {
        nameFound = record.name
    } else {
        return "No Record Found";
    }

    return nameFound;
};



export const getUserDetails = (request) => {
    try {
        const userString = sessionStorage.getItem("userInfo");
        if (!userString) {
            throw new Error("No user details found in session storage");
        }
        const user = JSON.parse(userString);
        if (!user) {
            throw new Error("User details are empty");
        }

        const role = user.role || "";
        const Id = user.id || "";
        const branch_id = user.branch_id || "";
        const user_name_id = user.user_name_id || "";
        const user_name = user.name || "";


        switch (request) {
            case "roleId":
                return role;
            case "Id":
                return parseInt(Id);
            case "profile":
                return user;
            case "branchId":
                return branch_id;
            case "userName":
                return user_name;
            case "userNameId":
                return user_name_id;
            default:
                throw new Error("Invalid request parameter");
        }
    } catch (error) {
        console.error("Error in getUserDetails:", error.message);
        return null;
    }
};

// Helper function to get sub-categories by category ID
export const getSubCategoriesByCategoryId = (categoryId) => {
    const category = staffCategories.find(cat => cat.id === categoryId);
    return category ? category.subCategories : [];
};

// Helper function to get category by ID
export const getCategoryById = (categoryId) => {
    return staffCategories.find(cat => cat.id === categoryId);
};


// Format payment mode
export const paymentModes = {
        'cash': 'Cash',
        'insurance': 'Insurance',
        'checks': 'Checks',
        'mobile': 'Mobile Money',
        'corporate': 'Corporate',
        'payway': 'Payway',
    };
export const getPaymentMode = (mode) => {

    return paymentModes[mode] || mode;
};


